import { Cepage } from './cepage.model';
import { StockCode } from './enums/stock.enum';
import { DataIdArrayConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Produit } from '../../habilitation/models/produit.model';
import { Site } from './site.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class ChangementDenomination {
    static jsonMap = {
        idMouvement: { key: 'idMouvement', optional: true },
        codeProduitOrigine: { key: 'codeProduitOrigine', optional: true, default: '' },
        codeProduitDestination: { key: 'codeProduitDestination', optional: true, default: '' },
        quantite: { key: 'quantite' },
        logement: { key: 'logement', optional: true, default: '' },
        typeConditionnement: { key: 'typeConditionnement', optional: true, default: '' },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        idSite: { key: 'idSite' },
        codeStock: { key: 'codeStock' },
        cepages: { key: 'idsCepages', converter: new (DataIdArrayConverterFactory.build(Cepage, 'cepages'))(), optional: true, default: () => [] },
        observation: { key: 'observation', optional: true, default: '' },
        typeChangement: { key: 'typeChangement', optional: true, default: '' },
        idMouvementLie: { key: 'idMouvementLie', optional: true }
    };

    idMouvement: number;
    codeProduitOrigine: string;
    codeProduitDestination: string;
    quantite: number;
    logement: string;
    typeConditionnement: string;
    numeroLot: string;
    idSite: number;
    codeStock: StockCode;
    cepages: Cepage[];
    observation: string;
    typeChangement: string;
    idMouvementLie: number;

    produitOrigine: Produit;
    produitDestination: Produit;
    site: Site;
    idOperateur: number;
}
